import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ModalAddguestComponent } from "../modal-addguest/modal-addguest.component";
import { CloudbedsService } from "@app/services/cloudbeds.service";
import { Storage } from "@ionic/storage";
import { AlertService } from "@app/shared/services/alert.service";
import { CodebaseTranslateService } from "@app/services/codebase-translate.service";
import { ModalInstructionsComponent } from "@app/codebase/roommap/modal-instructions/modal-instructions.component";
import { environment } from "@env/environment";

@Component({
  selector: "app-myroom",
  templateUrl: "./myroom.component.html",
  styleUrls: ["./myroom.component.scss"],
})
export class MyroomComponent implements OnInit {
  @Input() reservation: any;
  @Input() title: any;
  public firstFloor: boolean = false;
  public addGuest: boolean;
  constructor(
    private modalCtrlr: ModalController,
    public storage: Storage,
    public translateService: CodebaseTranslateService,
    private alertService: AlertService,
    private cloudbedsService: CloudbedsService
  ) {}

  async ngOnInit() {
    console.log(this.reservation);
    this.reservation = await this.storage.get("reservationData");
    if (this.reservation.assigned[0].roomName.substring(0, 1) == "1")
      this.firstFloor = true;
    else this.firstFloor = false;
  }

  goBack() {
    this.modalCtrlr.dismiss();
  }

  async find() {
    console.log(this.addGuest);
    if (this.addGuest) {
      this.openAddGuesModal();
    }
    this.goBack();
    // this.cloudbedsService.findReservation("6278034245206").then(res => {
    // this.modalCtrlr.dismiss({result: true});
    // });
  }

  checkin() {
    if (this.addGuest) {
      this.openAddGuesModal();
    } else {
      this.confirmCheckIn();
    }
  }

  async showInstructions() {
    const modal = await this.modalCtrlr.create({
      cssClass: "instructions-info-modal",
      component: ModalInstructionsComponent,
      componentProps: {
        title: this.translateService.instant("INSTRUCTIONS.LBL_TITLE"),
        steps: [
          { icon: 'assets/map/instructions/destination-pin.svg', label: this.translateService.instant("INSTRUCTIONS.STEP1") },
          { icon: 'assets/map/instructions/turnleft.png', label: this.translateService.instant("INSTRUCTIONS.STEP2") },
          { icon: 'assets/map/instructions/move.png', label: this.translateService.instant("INSTRUCTIONS.STEP3") },
          { icon: 'assets/map/instructions/turnleft.png', label: this.translateService.instant("INSTRUCTIONS.STEP4") },
          { icon: 'assets/map/instructions/destination-pin.svg', label: this.translateService.instant("INSTRUCTIONS.STEP5") },
        ],
      },
    });
    await modal.present().then((result) => {});
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.value === "whatsapp") {
      window.open("https://wa.me/5213314113080");
    } else if (data && data.value === "call") {
      window.location.href = "tel:523314113080";
    }
  }

  confirmCheckIn() {
    if (!environment.nexi.simulateCheckIn) {
      this.cloudbedsService
        .checkin(this.reservation.reservationID)
        .then((result) => {
          this.storage.set("reservationData", this.reservation);
          this.modalCtrlr.dismiss({ result: true });
        })
        .catch(async (res) => {
          console.log(res);
          await this.alertService.presentInfoAlert(res.error, "Error", [
            { text: "Dismiss" },
          ]);
        });
    }
    else {
      this.storage.set("reservationData", this.reservation);
      this.modalCtrlr.dismiss({ result: true });
    }
  }
  async openAddGuesModal() {
    const modal = await this.modalCtrlr.create({
      cssClass: "ad-alert-modal",
      component: ModalAddguestComponent,
      componentProps: {
        title: "",
        reservationId: this.reservation.reservationID,
        buttons: [
          {
            title: "Dismiss",
            value: "cancel",
          },
        ],
      },
    });
    await modal.present().then((result) => {});
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    console.log(data);
    this.confirmCheckIn();
    if (data && data.result) {
      this.confirmCheckIn();
    } else {
      await this.alertService.presentInfoAlert(data.message, "Error", [
        { text: "Dismiss" },
      ]);
    }
  }
}
